import { Stack, Typography } from '@mui/joy';
import { PencilSimpleLine, TrashSimple } from '@phosphor-icons/react';
import { ICellRendererParams } from 'ag-grid-community';

import { EditItemButton, RemoveItemsButton } from 'partBoms/components/PartBomDetails';
import { IPartBom, IPartBomItem } from 'partBoms/types';
import { Color, Direction, Level } from 'theme/enums';

interface IProps extends ICellRendererParams {
  data: IPartBomItem;
  partBom: IPartBom;
}

export const ActionsCell = ({ data, partBom, api }: IProps) => {
  if (!data) {
    return null;
  }

  const onRemove = () => api.applyTransaction({ remove: [data] });

  return (
    <Stack direction={Direction.ROW} gap={1}>
      <EditItemButton
        partBom={partBom}
        partBomItem={data}
        buttonElement={
          <Typography color={Color.PRIMARY} level={Level.BODY_SM} sx={{ cursor: 'pointer' }}>
            <PencilSimpleLine />
          </Typography>
        }
      />

      <RemoveItemsButton
        items={[data]}
        buttonElement={
          <Typography color={Color.DANGER} level={Level.BODY_SM} sx={{ cursor: 'pointer' }}>
            <TrashSimple />
          </Typography>
        }
        onRemoveSuccess={onRemove}
      />
    </Stack>
  );
};
